import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import Loader from 'features/Loader/Loader';
import { calculateLastActive } from 'utils/date';
import { connect } from 'react-redux';
import { firstLetters } from 'utils/strings';
import './Assessment.scss';

const Assessments = props => {
  const { client, assessments, trainer, loadingAssessment } = props;

  if (loadingAssessment) {
    return(<Loader/>);
  }
  return (
    <section className="notes-tab">
      <div className="notes-list">
        <ul>
          {assessments.map(element => {
            return createAssessmentTile(element, client, trainer);
          })}
        </ul>
      </div>
    </section>
  );
};

const createAssessmentTile = (element, client, trainer) => {
  let name = `${trainer?.first_name} ${trainer?.last_name}`;

  return (
    <li key={element.id}>
      <div className="note-item">
        <Avatar
          src={trainer?.photo || ''}
          width="32"
          height="32"
          name={name}
          firstLetters={firstLetters(name)}
          text={
            element.created_at ? calculateLastActive(element.created_at) : ''
          }
        />
        <a href={`/clients/${client.id}/assessments/${element.id}`}>
          <h4>New Assessment added</h4>
          <p className="note-content">{element.assessment_type}</p>
        </a>
      </div>
    </li>
  );
};

function mapStateToProps(state) {
  return {
    trainer: state.trainerProfileReducer.trainer,
    loadingAssessment: state.assessmentsReducer.loading
  };
}

export default connect(mapStateToProps, null)(Assessments);
